<form [formGroup]="form">
  <div class="coupon-code-input-wrapper p-2 clearfix">
    <div class="c-pointer d-flex align-items-center justify-content-between" (click)="open()">
      <span for="cart_coupon_code" class="coupon_label" [class.copen]="!display">
        {{ 'ACTION_CODE.enterCode' | alpitranslate }}
      </span>
      <app-icon
        name="chevronRight"
        class="expandForm"
        [class.open]="display"
        data-test="expandCouponCodeInput" />
    </div>
    @if (display) {
      <div @collapsible (@collapsible.done)="onExpandDone($event)" class="spacer">
        <div class="input-group collapsible" name="alpin-coupon-code">
          <input
            #couponInput
            [autocomplete]="'off'"
            type="text"
            id="cart_coupon_code"
            name="promotionCode"
            formControlName="promotionCode"
            class="form-control"
            (keyup)="keyupOnField($any($event.target).value)"
            (change)="keyupOnField($any($event.target).value)"
            (keydown.enter)="$event.preventDefault(); clickedRedeem()"
            (focus)="onPromotionCode = true"
            (blur)="onPromotionCode = false"
            [class.label-shrink]="form.get('promotionCode').value.length > 0 || onPromotionCode"
            [class.valid]="form.get('promotionCode').value.length > 0 && promocodeState === PROMOCODE_VALID"
            [class.invalid]="
              form.get('promotionCode').value.length > 0 && promocodeState === PROMOCODE_INVALID && !searching
            " />

          <button
            class="redeem-btn btn btn-primary"
            (click)="clickedRedeem()"
            data-test="redeem-btn"
            type="button">
            @if (!searching) {
              <span>{{ 'ACTION_CODE.redeem' | alpitranslate }}</span>
            } @else {
              <div class="spinner-border spinner-border-sm" role="status"></div>
            }
          </button>
        </div>
        <small class="p-1 d-block">
          <div id="mmWrapper"></div>
        </small>
        @if (!searching && promocodeState === PROMOCODE_INVALID) {
          <p
            class="finalise-booking__not-valid finalise-booking__not-valid--couponCode ng-binding mt-1 text-danger"
            data-test="invalid-coupon-code-text">
            <app-icon name="stop" class="mr-2" /> {{ 'ACTION_CODE.invalid' | alpitranslate }}
          </p>
        }
        @for (code of actionCodes; track code) {
          @if (code.type === 'promotioncode') {
            <div class="clearfix mt-2 code" @collapsible>
              <span class="code-text" data-test="promo-code-text-container">
                <span data-test="promo-code-text">{{ code.text }} </span>
                <span data-test="promo-code-text-decription" class="code-desc font-italic">
                  (
                  {{ 'ACTION_CODE.promo' | alpitranslate }}
                  )
                </span>
              </span>
              <span class="float-right explanation" data-test="coupon-code-tremove-icon"
                ><app-icon name="bin" (click)="removeActioncode(code)" class="text-primary c-pointer"
              /></span>
            </div>
            @if (code.text.toUpperCase().includes('MASTER')) {
              <div style="font-size: 0.75rem; opacity: 0.75">
                <span>{{ 'ACTION_CODE.conditionNote' | alpitranslate }}</span>
              </div>
            }
          }
          @if (code.type === 'couponcode') {
            <div class="clearfix mt-2 code" @collapsible>
              <span class="code-text" data-test="coupon-code-text-container">
                <span data-test="coupon-code-text">{{ code.text }} </span>
                <span data-test="coupon-code-text-decription" class="code-desc font-italic">
                  (
                  {{ 'ACTION_CODE.coupon' | alpitranslate }}
                  )
                </span>
              </span>
              <span class="float-right explanation" data-test="coupon-code-tremove-icon"
                ><app-icon name="bin" (click)="removeActioncode(code)" class="text-primary c-pointer"
              /></span>
            </div>
          }
        }
        <!-- total listing of coupon values from cart -->
        @if (rates && getCoupon()) {
          <div @collapsible class="mt-1">
            <div class="mb-1">
              <span data-test="coupon-code-balance">{{ 'ACTION_CODE.couponBalance' | alpitranslate }}</span>
              <span data-test="coupon-code-balance-value" class="float-right">
                {{
                  { amount: getCoupon().euroBalanceRaw, currency: rates }
                    | alpicurrency: currencyService.actualCurrency
                }}
              </span>
            </div>
            <div class="mb-1">
              <span data-test="coupon-code-redeemed">{{
                'ACTION_CODE.couponRedeemedValue' | alpitranslate
              }}</span>
              <span data-test="coupon-code-redeemed-value" class="float-right">{{
                { amount: totalDeductedFromCoupons.amount, currency: rates }
                  | alpicurrency: currencyService.actualCurrency
              }}</span>
            </div>
            <div>
              <hr />
            </div>
            <div>
              <span data-test="coupon-code-remaining">{{
                'ACTION_CODE.couponRemainingValue' | alpitranslate
              }}</span>
              <span data-test="coupon-code-remaining-value" class="float-right">{{
                totalCouponRemaining() | alpicurrency: currencyService.actualCurrency
              }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
</form>
